import { render, staticRenderFns } from "./PointeApplications.vue?vue&type=template&id=2b1f61ac&scoped=true"
import script from "./PointeApplications.vue?vue&type=script&lang=js"
export * from "./PointeApplications.vue?vue&type=script&lang=js"
import style0 from "./PointeApplications.vue?vue&type=style&index=0&id=2b1f61ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f61ac",
  null
  
)

export default component.exports